import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import * as _ from 'lodash';

import { AppComponentGenericComponent } from '../../custom/app-component-generic/app-component-generic.component';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-gestione-ruoli',
  templateUrl: './gestione-ruoli.component.html',
  styleUrls: ['./gestione-ruoli.component.css']
})
export class GestioneRuoliComponent extends AppComponentGenericComponent implements OnInit {
	ruoliSync: Subscription;
	ruoliSource: any[] = [];
	ruoli: any[] = [];
	ruoliSelect: any[] = [];

	editingRuolo: any = {id:''};

	tipoNuovoRuolo: string = '';
	descrizioneNuovoRuolo: string = '';
	insertAfter: string = '';

	organize: boolean = false;

	constructor(protected dataService: DataService){
		super(dataService, 'gestione-ruoli');
	}

	ngOnInit() {
		this.ruoliSync = this.dataService.ruoli$.subscribe(
			ruoli => {
				this.ruoliSource = ruoli;
				this.ruoli = this.ruoliSource;
				this.updateRolesList();
			});
	}

	saveNewRole() {
		let lastLevel = Number(this.ruoli[this.ruoli.length-1].livello);
		let newRole = {
			tipo : this.tipoNuovoRuolo,
			descrizione : this.descrizioneNuovoRuolo,
			livello : lastLevel + 1
		}

		console.log(newRole);

		this.dataService.insert("livelli", newRole, false, (error,res) => {
			if (error) {
				console.log('INSERT ERROR',error);
			}
			else {
				console.log('INSERT SUCCESS',res);
			}
		});
	}

	editRole(index: any) {
		this.editingRuolo = _.cloneDeep(this.ruoli[index]);
		console.log('EDIT',index,this.editingRuolo);
	}

	confirmEditRole() {
		console.log('confirmEditRole', this.editingRuolo, this.editingRuolo.id);
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: this.editingRuolo.id });

		this.dataService.update("livelli", localFilters, this.editingRuolo, false, (error,res) => {
			if (error) {
				console.log(error);
			}
			else {
				console.log(res);
				this.undoEditRole();
			}
		});
	}

	undoEditRole() {
		this.editingRuolo = { id: '' }
	}

	deleteRole(index: any) {

		let toDelete = this.ruoli[index];
		let toUpdate = [];

		if ( index < (this.ruoli.length-1) ) {
			for (let ruolo of this.ruoli) {
				if ( Number(ruolo.livello) > Number(toDelete.livello) ) {
					toUpdate.push( this.levelDown(ruolo) );
				}
			}
			this.updateRolesList();
		}

		console.log('deleteRole',toDelete.id,index,this.ruoli.length,toUpdate);

		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: toDelete.id });

		this.dataService.delete("livelli", localFilters, true, (error,res) => {
			if (error) {
				console.log('delete role error');
				this.undoEditRole();
			}
			else {
				console.log('delete role success');
				this.saveOrganize();
			}
		});
	}

	moveUp(ruolo: any) {
		this.levelUp(ruolo);
		for (let _ruolo of this.ruoli) {
			if ( _ruolo.id != ruolo.id && _ruolo.livello == ruolo.livello ) {
				this.levelDown(_ruolo);
			}
		}
		this.updateRolesList();
	}

	levelUp(ruolo: any) {
		let oldValue = Number(ruolo.livello);
		let newValue = oldValue +1;
		ruolo.livello = newValue;
		return ruolo;
	}

	moveDown(ruolo: any) {
		this.levelDown(ruolo);
		for (let _ruolo of this.ruoli) {
			if ( _ruolo.id != ruolo.id && _ruolo.livello == ruolo.livello ) {
				this.levelUp(_ruolo);
			}
		}
		this.updateRolesList();
	}

	levelDown(ruolo: any) {
		let oldValue = Number(ruolo.livello);
		let newValue = oldValue -1;
		ruolo.livello = newValue;
		return ruolo;
	}

	updateRolesList() {
		this.ruoli = _.orderBy(this.ruoli, ['livello'], ['asc']);
	}

	saveOrganize() {
		console.log('saveOrganize')
		for (let ruolo of this.ruoli) {
			let localFilters = [];
			localFilters.push({ type: "=", key: "id", value: ruolo.id });

			this.dataService.update("livelli", localFilters, ruolo, false, (error,res) => {
				if (error) {
					console.log(error);
				}
				else {
					console.log(res);
				}
			});
		}

		this.organize = false;
	}

	undoOrganize() {
		console.log('undo organize');
		this.ruoli = this.ruoliSource;
		this.organize = false;
	}

	ngOnDestroy() {
		this.ruoliSync.unsubscribe();
	}
}
